export const DEFAULT_NX_CHARACTER_IMG_SIZE = {
  height: 300,
  width: 300,
};

// https://github.com/marpple/mp_lambda/tree/main/mp_lambda_api/prod-mp-lambda-image-resizer
export const IMG_RESIZE_LAMBDA_URL =
  'https://fkiy96dbdh.execute-api.ap-northeast-2.amazonaws.com/prod/nx_img_resize';

export const IMG_RESIZE = {
  URL: IMG_RESIZE_LAMBDA_URL,
  PARAMS: {
    height: 1920,
    width: 1920,
    kernel: 'nearest',
    // keep_ratio: false,
    // trim_margin: 0,
    response_format: 'webp',
    response_type: 'buffer',
  },
};

export const DEFAULT_CHARACTER =
  // '//s3.marpple.co/files/u_2798351/2024/12/original/6eaa2a75bd075a572df775978dbe991a7c0093e41.png';
  '//s3.marpple.co/files/u_2798351/2024/12/original/fcc845a01a063cbd531cf703d7842a075e259b302.png';

export const NO_CHARACTER =
  '//s3.marpple.co/files/u_2798351/2025/1/original/f3e32ffff5dc1d9945a2edc9d99e38f1442b1d551.png';

export const LOGO =
  '//s3.marpple.co/files/u_193535/2025/12/original/40eca033116dc1af7ec5451240b58a85ada509f81.png';

export const OLD_LOGO =
  '//s3.marpple.co/files/u_2798351/2025/1/original/5689fe22ede6fdca27ad9700f5eede9e73f4eff01.png';

export const DEFAULT_CHARACTER_WEBP =
  '//s3.marpple.co/files/u_2798351/2025/1/original/1928084abc65794118a3c7dbb8447658196346841.webp';

export const LABS_BG_IMG = (is_mobile) =>
  is_mobile
    ? '//s3.marpple.co/files/u_2798351/2024/12/original/03371888973167e4524abfddc44f527ac04c288b1.png'
    : '//s3.marpple.co/files/u_2798351/2024/12/original/d9f329b5c55daa7a66e3bd8eae264027ec42a4a61.png';

export const CHARACTER_CANVAS_SIZE = {
  PC: {
    MAIN: 1024,
    THUMBNAIL: {
      SIZE: 300,
      CROP_WIDTH: 120,
      CROP_HEIGHT: 120,
    },
  },
  MOBILE: {
    MAIN: 800,
    THUMBNAIL: {
      SIZE: 300,
      CROP_WIDTH: 120,
      CROP_HEIGHT: 120,
    },
  },
};

export const SLIDE_PER_VIEW = 10;
export const SLIDE_ITEM_WIDTH = 88;
export const SLIDE_ITEM_GAP = 8;
export const SLIDE_SIDE_PADDING = 24;

export const NEXON_IMAGE_URL_DOMAINS = [
  '//nxsvc.inface.nexon.com',
  '//test-nxsvc.inface.nexon.com', // 스테이징 환경용
  '//avatar.maplestory.nexon.com',
];
